export default [
  { text: 'Frau', value: 'FEMALE' },
  { text: 'Mann', value: 'MALE' },
  { text: 'Unternehmen', value: 'COMPANY' },
]
